import React, { useState, useEffect } from 'react';
import { Avatar, Menu, MenuItem, IconButton, Typography } from '@mui/material';
import { AccountCircle } from '@mui/icons-material';
import {auth} from '../firebase'; // Firebase 초기화 파일 경로
import {onAuthStateChanged, GoogleAuthProvider, signInWithPopup, signOut} from 'firebase/auth';
import {useNavigate} from "react-router-dom";
import {useRecoilState} from "recoil";
import {userState} from "../atom/common"; // Firebase 초기화 파일 경로

const LoginStatus = () => {
  const [user, setUser] = useState(null); // 사용자 상태 관리
  const [anchorEl, setAnchorEl] = useState(null); // 메뉴 열기/닫기 상태 관리
  const navigate = useNavigate();
  const [loginUser, setLoginUser] = useRecoilState(userState)

  useEffect(() => {
    // 인증 상태 변경 감지
    const unsubscribe = onAuthStateChanged(auth, user => {
      if (user) {
        setUser(user); // 로그인 상태 업데이트
        setLoginUser({'email': user.email})
      } else {
        setUser(null); // 로그아웃 상태 업데이트
        setLoginUser({'email': ''})
      }
    });

    return () => unsubscribe(); // Clean-up 함수
  }, []);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget); // 메뉴 열기
  };

  const handleMenuClose = () => {
    setAnchorEl(null); // 메뉴 닫기
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      setUser(null); // 로그아웃 후 사용자 상태 업데이트
      setAnchorEl(null); // 메뉴 닫기
      alert('로그아웃 되었습니다.');
      navigate("/trade")
    } catch (error) {
      console.error('Error signing out:', error.message);
      alert('로그아웃에 실패하였습니다. 다시 시도해주세요.');
    }
  };

  return (
    <div>
      {user ? (
        <div style={{display: 'flex', alignItems: 'center'}}>
          <IconButton onClick={handleMenuOpen}>
            <Avatar alt={user.displayName || user.email} src={user.photoURL}>
              <AccountCircle/>
            </Avatar>
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            anchorOrigin={{
              vertical: 'bottom', // 메뉴가 아바타 아래에 위치하도록 설정
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top', // 메뉴가 아바타 아래에서 펼쳐지도록 설정
              horizontal: 'right',
            }}
          >
            <MenuItem onClick={handleLogout}>로그아웃</MenuItem>
          </Menu>
        </div>
      ) : (
        <Typography variant="body1" onClick={() => signInWithPopup(auth, new GoogleAuthProvider())}>
        </Typography>
      )}
    </div>
  );
};

export default LoginStatus;
